// extracted by mini-css-extract-plugin
module.exports = {"root":"_ee9ea6"};